<template>
    <layout-gestao>
    	<div class="row">
			<div class="col-sm-12">
				<form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="saveItem" @submit.prevent="">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-6">
                            <div class="form-group">
                                <MaterialInput :readonly="readonlyFormItem" type="text" class="city-form-group city-bg" id="input-name" name="name" v-model.trim="form.name" v-validate="'required|min:3'" :inputClasses="[{'is-invalid': fnHasError('name') }]" :error=" fnFirstError('name')">Nome</MaterialInput>
                            </div>
                        </div>
						<div class="col-xl-6">
                            <div class="form-group">
                                <div class="form-group">
                                <MaterialSelect :disabled="readonlyFormItem" class="city-form-group city-bg" id="input-parish_id" name="parish_id" label="name" :filterable="true" :options="lists.parishes" v-model.trim="form.parish_id" v-validate="'required'" :reduceObject="false" :inputClasses="[{'is-invalid': fnHasError('parish_id') }]" :error=" fnFirstError('parish_id')">Freguesia</MaterialSelect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="saveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    >
                    </buttons-footer>
                </form>
			</div>
    	</div>
    </layout-gestao>
</template>

<script>
	import mixin from '../../mixin'

  	export default {
  		mixins: [mixin],
    	data() {
      		return {
      			pageID: 'cps',
        		form: {
				    id: null,
				    name: null,
					parish_id: null,
                    parish: null
	            },
                lists: {
                    parishes: [],
                    loaded: false
                }
      		}
    	},
		computed: {
		},
    	created(){
			this.loadAuxiliaries();
    	},
    	methods: {
			async loadAuxiliaries() {
				if (!this.lists.loaded && this.url.getLists) {
					await this.$http.get(this.url.getLists)
					.then(res => {
						let data = res.data;
						this.lists.parishes = data.parishes;
						this.lists.loaded = true;
					})
					.catch(error =>
					{
						this.lists.loaded = false;
						this.showHttpError(error);
					})
				}
			}
    	}
  	}
</script>

<style scoped lang="scss">

</style>

